<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-16 10:39:06
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-19 10:43:18
 * @FilePath: /chaoyongtuan/src/views/teamManage/performanceManage/components/overview/infoItem.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="info-item-wrapper">
		<div class="color-gy-7 font-h6-regular flex">
			{{ item.label }}
			<explain
				style="margin-left: 4px"
				:content="item.desc"
				placement="bottom"
				:size="14"
				icon="icon-a-help-circlebangzhu-mian"
				v-if="item.desc"
			></explain>
		</div>
		<div class="price text" v-if="item.showPrice">
			<span class="fz-18 font-bold">¥{{ prices(item.number)[0] }}</span>
			<span class="fz-18 font-bold" v-if="prices(item.number)[1]">.{{ prices(item.number)[1] }}</span>
		</div>
		<div class="num text" v-else>{{ item.number }}</div>
	</div>
</template>
<script>
import Explain from '@/components/common/explain';
export default {
	props: {
		item: {
			props: Object,
			default: () => {},
		},
	},
	components: {
		Explain,
	},
	computed: {
		prices() {
			return num => `${num}`.split('.');
		},
	},
};
</script>
<style lang="less" scoped>
.info-item-wrapper {
	width: calc(calc(100% - 48px) / 5);
	border: 1px solid @color-gy4;
	box-sizing: border-box;
	border-radius: 8px;
	/* 自动布局 */
	display: flex;
	flex-direction: column;
	padding: 16px;
	/* 全局/white */
	background: @color-gy1;
	position: relative;
	.text {
		font-size: 20px;
		font-family: 'Barlow-Bold';
		color: @color-text-primary;
	}
}
</style>
